<template>
  <b-tab title="Armazenados" class="m-0 p-0">
    <div class="tab-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE EQUIPAMENTOS ARMAZENADOS :::::::::::::::::::::::::::: -->
      <b-table bordered hover small head-variant="light" :items="getFilterArmazenados(filtro)" :fields="fields.armazem">
        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)" v-b-tooltip.hover title="Editar">
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="deletar(data.item)" v-b-tooltip.hover title="Deletar">
              <b-icon icon="trash-fill" variant="danger"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- :::::::::::::::::::::::::::: BARRA DE AÇÕES :::::::::::::::::::::::::::: -->
    <div class="menu-acoes pb-2">
      <div id="search-bar">
        <b-col cols="12" class="p-1 pr-0">
          <b-form inline>
            <b-button size="sm" class="pl-2 pr-3" variant="info" @click="adicionar()">
              <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
            </b-button>
            <b-form-input
              id="atv-desc-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Descrição"
              v-model="filtro.descricao"
            />
            <b-form-input
              id="atv-cod-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Código"
              v-model="filtro.codigo"
            />
            <b-form-input
              id="atv-estado-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Estado"
              v-model="filtro.estado"
            />
            <b-icon icon="search" variant="light" scale="1.2" class="m-1" />
            <b-button size="sm" class="m-1 ml-3" variant="light">
              {{ quantidade + " armazenados" }}
            </b-button>
          </b-form>
        </b-col>
      </div>
      <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
      <armazem-modal ref="editorArmazenados" />
      <confirm-modal
        ref="confirmDelArmazenado"
        :descricao="'Deseja realmente remover o item armazenado ?'"
        @executar="executar()"
      />
    </div>
  </b-tab>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useArmazemStore } from "@/stores/ArmazemStore";
import Armazem from "@/models/Armazem";
import TableFields from "@/tools/TableFields";
import ArmazemModal from "@/components/modals/armazem/ArmazemModal";
import ConfirmModal from "@/components/modals/diversos/ConfirmModal.vue";

export default {
  name: "ArmazemTabList",

  data() {
    return {
      fields: new TableFields(),
      filtro: {
        descricao: "",
        codigo: "",
        estado: "",
      },
      armazem: new Armazem(0, "Novo Equipamento", "", "", 0, "informações importantes sobre o equipamento."),
    };
  },

  components: {
    "armazem-modal": ArmazemModal,
    "confirm-modal": ConfirmModal,
  },

  computed: {
    quantidade() {
      return this.getFilterArmazenados(this.filtro).length;
    },
  },

  methods: {
    adicionar() {
      this.armazem = new Armazem(0, "Novo Equipamento", "", "", 0, "informações importantes sobre o equipamento.");
      this.$refs.editorArmazenados.call(this.armazem);
    },

    editar(armazem) {
      this.$refs.editorArmazenados.call(armazem);
    },

    deletar(armazem) {
      this.armazem.update(armazem);
      this.$refs.confirmDelArmazenado.call();
    },

    executar() {
      this.armazemStore.LISTAR_ARMAZENADOS(this.armazem.id).then(() => {
        this.armazemStore.REMOVER_ARMAZENADOS(this.armazem.id);
      });
    },
  },

  setup() {
    const store = useSgcqStore();
    const armazemStore = useArmazemStore();
    const { getFilterArmazenados } = storeToRefs(armazemStore);

    return {
      store,
      armazemStore,
      getFilterArmazenados,
    };
  },
};
</script>

<style lang="scss" scoped>
#atv-desc-filter {
  width: 18rem;
}
#atv-cod-filter {
  width: 14rem;
}
#atv-estado-filter {
  width: 14rem;
}
.menu-acoes {
  background-color: #112a4a;
}
</style>
